export default __webpack_public_path__ + "static/media/check-round-outline-green-16px.f8618a87.svg";